import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import CategoryList from "features/storages/categories/categoryList"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import RightSidebar from "components/sidebar/right/RightSidebar"
import Button from "components/inputs/button"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import PageTitle from "features/navigation/pageTitle"
import useAccess from "@/hooks/useAccess"
import useStorages from "@/hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import { AccessRole, DeviceSize } from "@/types"
import IconButton from "@/components/buttons/iconButton"
import useWindowDimensions from "@/hooks/useWindowDimensions"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const Categories = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const { displayIfSize } = useWindowDimensions()

    const { targetStorageDocId: storageId } = useTargetStorage()
    const { storage, storageStatus } = useStorages({ storageId })
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleCategories')} />
            <MainSheetHeaderActions>
                { limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) &&
                    <>
                        {!displayIfSize([DeviceSize.SM]) && <Button wideOnMobile design="primary" to={`/storages/${safeStorageId}/categories/create`}><AddIcon /><span>{t(`buttonNewCategory`)}</span></Button>}
                        {displayIfSize([DeviceSize.SM]) && <IconButton colorScheme="blue" icon={<AddIcon />} to={`/storages/${safeStorageId}/categories/create`} />}
                    </>
                }
            </MainSheetHeaderActions>
            <Callout type="info" id={`category-page-info`}>{t('categoriesInfo')}</Callout>
            <Section padX={false}>
                <CategoryList storageId={safeStorageId} />
            </Section>
            <RightSidebar storageId={safeStorageId} />
        </>
    )
}

export default Categories